import { DefaultId } from '../shared/Globals'
import { LanguageId } from '../shared/Language'
import { getInvestor } from './ApiHooks'

const LANGUAGE_ALIAS = "LANG"
export const NOTIFICATIONS_ALIAS = "NOTI"

export const getLanguage = (): string => {
    const result = localStorage.getItem(LANGUAGE_ALIAS)
    if (result) return result
    return DefaultId
}

export const setLanguage = (language: LanguageId) => {
    if (getLanguage() === language) return;
    localStorage.setItem(LANGUAGE_ALIAS, language)
    window.location.reload()
}

export const checkLanguageHasBeenSet = async (): Promise<void> => {
    const result = localStorage.getItem(LANGUAGE_ALIAS)
    if (result) return;
    const investor = await getInvestor()
    if (investor && investor.language) setLanguage(investor.language)
    else setLanguage("da")
}

export const getLocalItem = (alias: string): string | undefined => {
    const result = localStorage.getItem(alias)
    if (result) return result
    return undefined
}

export const setLocalItem = (alias: string, item?: string) => {
    if(item) localStorage.setItem(alias, item)
    else localStorage.removeItem(alias)
    window.dispatchEvent(new Event("storage"))
}